module.exports = __webpack_public_path__ + "static/media/Subtraction 1.7fdc37c8.svg";